(function () {
  const STORAGE_KEY = 'ruann-cart-restore';
  const MANUAL_KEY = 'ruann-currency-manual';
  const AUTO_KEY = 'ruann-currency-auto';

  function snapshotItems(cart) {
    return (cart.items || []).map(function (item) {
      return {
        id: item.variant_id || item.id,
        quantity: item.quantity,
        properties: item.properties || {},
      };
    });
  }

  function switchCountry(countryCode) {
    if (!countryCode) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        const items = snapshotItems(cart);
        if (items.length) {
          try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
          } catch (err) {}
        }

        const url = new URL(window.location.href);
        if (url.pathname === '/localization') url.pathname = '/cart';
        url.searchParams.set('country', countryCode);
        window.location.assign(url.toString());
      });
  }

  function restoreCartIfNeeded() {
    let raw;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
    } catch (err) {
      return;
    }
    if (!raw) return;

    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (err) {}

    var items;
    try {
      items = JSON.parse(raw);
    } catch (err) {
      return;
    }
    if (!items || !items.length) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && cart.item_count > 0) return null;

        return items.reduce(function (chain, item) {
          return chain.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'include',
              headers: { Accept: 'application/json' },
              body: (function () {
                const body = new URLSearchParams();
                body.set('id', String(parseInt(item.id, 10) || item.id));
                body.set('quantity', String(item.quantity || 1));
                const props = item.properties || {};
                Object.keys(props).forEach(function (key) {
                  if (props[key] != null && props[key] !== '') {
                    body.set('properties[' + key + ']', String(props[key]));
                  }
                });
                return body;
              })(),
            }).then(function (res) {
              return res.text().then(function (text) {
                const trimmed = (text || '').trim();
                if (!trimmed || (trimmed.charAt(0) !== '{' && trimmed.charAt(0) !== '[')) return {};
                try { return JSON.parse(trimmed); } catch (err) { return {}; }
              });
            }).catch(function () {});
          });
        }, Promise.resolve()).then(function () {
          window.location.reload();
        });
      })
      .catch(function () {});
  }

  function rememberManualChoice() {
    try {
      sessionStorage.setItem(MANUAL_KEY, '1');
    } catch (err) {}
  }

  function currentCountry() {
    try {
      const queryCountry = new URLSearchParams(window.location.search).get('country');
      if (queryCountry) return String(queryCountry).toUpperCase();
    } catch (err) {}
    if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase();
    const select = document.querySelector('[data-ruann-currency]');
    if (select) {
      const fromData = select.getAttribute('data-current-country');
      if (fromData) return String(fromData).toUpperCase();
      if (select.value) return String(select.value).toUpperCase();
    }
    return '';
  }

  function suggestionCountry(data) {
    if (!data) return '';
    const detected = data.detected_values && data.detected_values.country;
    if (detected && (detected.handle || detected.iso_code)) {
      return String(detected.handle || detected.iso_code).toUpperCase();
    }
    const suggestion = data.suggestions && data.suggestions[0];
    const parts = suggestion && suggestion.parts;
    const country = parts && parts.country;
    if (country && (country.handle || country.iso_code)) {
      return String(country.handle || country.iso_code).toUpperCase();
    }
    return '';
  }

  function autoSwitchToVisitorMarket() {
    try {
      if (sessionStorage.getItem(MANUAL_KEY) === '1') return;
    } catch (err) {}

    try {
      if (new URLSearchParams(window.location.search).has('country')) return;
    } catch (err) {}

    const current = currentCountry();
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const url =
      root +
      'browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true';

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const detected = suggestionCountry(data);
        if (!detected || detected === current) return;

        try {
          if (sessionStorage.getItem(AUTO_KEY) === detected) return;
          sessionStorage.setItem(AUTO_KEY, detected);
        } catch (err) {}

        switchCountry(detected);
      })
      .catch(function () {});
  }

  document.addEventListener(
    'change',
    function (event) {
      const select = event.target;
      if (!select || select.tagName !== 'SELECT') return;
      if (select.getAttribute('name') !== 'country_code' && !select.hasAttribute('data-ruann-currency')) return;
      event.preventDefault();
      event.stopPropagation();
      rememberManualChoice();
      switchCountry(select.value);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || !form.action || form.action.indexOf('/localization') === -1) return;
      event.preventDefault();
      event.stopPropagation();
      const select = form.querySelector('[name="country_code"]');
      if (select && select.value) {
        rememberManualChoice();
        switchCountry(select.value);
      }
    },
    true
  );

  restoreCartIfNeeded();
  autoSwitchToVisitorMarket();
})();
